import type { NativeToolbarSpacerProps } from './types';

export const NativeToolbarSpacer: React.FC<NativeToolbarSpacerProps> = () => null;
